import { produce } from "immer";
import * as Actions from "pages/Quarantine/store/singleQuarantineActions";

import deepmerge from "deepmerge";
import combineMerge from "config/combineMerge";

const initialState = { byId: {}, allIds: [] };
const singleQuarantineReducer = produce((draft, action) => {
  switch (action.type) {
    case Actions.FETCH_SINGLE_QUARANTINE_SUCCESS: {
      const payload = action.payload;
      const singleQuarantine = payload.singleQuarantine;
      const singleQuarantineId = payload.id;

      const allIds = [singleQuarantineId];
      const byId = {
        [singleQuarantineId]: singleQuarantine
      };

      draft.byId = deepmerge(draft.byId, byId, {
        arrayMerge: combineMerge
      });

      draft.allIds = deepmerge(draft.allIds, allIds, {
        arrayMerge: combineMerge
      });

      break;
    }
    default:
      return draft;
  }
}, initialState);

export default singleQuarantineReducer;
